import script from "./InputCheckbox.vue?vue&type=script&setup=true&lang=ts"
export * from "./InputCheckbox.vue?vue&type=script&setup=true&lang=ts"

import "./InputCheckbox.vue?vue&type=style&index=0&id=81b77c80&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-81b77c80"]])

export default __exports__